var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.8,
    height: 28.8,
    viewBox: "0 0 6.827 6.827",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".sync_svg__fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sync_svg__Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sync_svg___490160136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "sync_svg___490160352",
    className: "sync_svg__fil0",
    d: "M0 0h6.827v6.827H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sync_svg___490160616",
    className: "sync_svg__fil0",
    d: "M.853.853h5.12v5.12H.853z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.418 1.78a2.537 2.537 0 01.598-.527l-.001-.002.093-.054A2.561 2.561 0 015.863 4.08l-.027.103-.412-.11.028-.104a2.142 2.142 0 00-.214-1.62 2.134 2.134 0 00-2.917-.781l-.024.013a2.138 2.138 0 00-.56.481l.48-.02.016.426-1.075.044-.041-.17-.225-.918.414-.1.112.456z",
    fill: "#00f6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.409 5.047a2.548 2.548 0 01-.69.582A2.561 2.561 0 01.963 2.748l.028-.103.412.11-.028.103a2.142 2.142 0 00.213 1.62 2.134 2.134 0 003.5.287l-.478.02-.017-.426 1.075-.044.042.17.224.918-.414.1-.111-.456z",
    fill: "#00e6ee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.5c0ba5e835ced0983c35f1c46cdf869d.svg";
export { ForwardRef as ReactComponent };